module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/5@2x_ba21999fc123b0e11baf72372fa1e633.png";